(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["find-your-team"] && !window.DesignMode) return;
  try {
    
    var league = document.querySelectorAll('.league');

    for (var i = 0; i < league.length; i++) {
        league[i].addEventListener('click', function(e) {
            var currentActiveElements = document.querySelectorAll('.find-your-team-section .active');

            // removing existing active classes from current active league and teams on click event
            for(var j = 0; j < currentActiveElements.length; j++) {
                currentActiveElements[j].classList.toggle('active');
            }

            // adding active class on clicked league on click event
            this.classList.toggle('active');
            
            // adding active class on teams based on active league on click event
            var teamsToShow = null;
            if(this.classList.contains('league-nav-mlb')) {
                teamsToShow = document.querySelectorAll('.league-mlb');
            }
            else if(this.classList.contains('league-nav-nhl')) {
                teamsToShow = document.querySelectorAll('.league-nhl');
            }
            else if(this.classList.contains('league-nav-nba')) {
                teamsToShow = document.querySelectorAll('.league-nba');
            }
            else if(this.classList.contains('league-nav-nfl')) {
                teamsToShow = document.querySelectorAll('.league-nfl');
            }
            else if(this.classList.contains('league-nav-ncaa')) {
                teamsToShow = document.querySelectorAll('.league-ncaa');
            }
            else if(this.classList.contains('league-nav-soccer')) {
                teamsToShow = document.querySelectorAll('.league-soccer');
            }
            for(var j = 0; j < teamsToShow.length; j++) {
                teamsToShow[j].classList.toggle('active');
            }         
        });
    }

  } catch(e) { console.error(e); }
})();

})();
